import { Segmented } from 'antd';
import { useCategoryOptions } from './hooks/useCategoryOptions';

export interface CategoryNavigationProps {
  categories: readonly string[];
  value: string;
  onChange: (value: string) => void;
}

export function CategoryNavigation({
  categories,
  value,
  onChange,
}: CategoryNavigationProps) {
  const options = useCategoryOptions(categories);

  return (
    <Segmented
      block
      options={options}
      value={value}
      onChange={(nextValue) => onChange(String(nextValue))}
      className="platform-settings-categories"
    />
  );
}
